import React from "react";

const Footer = () => {

        return(
            
    <footer className="bg-gray-950 p-4">
        
        <div className="container mx-auto text-center ">
            <p className="text-white text-sm mb-0">&copy;{new Date().getFullYear()} Reza Aldino. all right reserved</p>
          
        </div>
    </footer>
        )
}

export default Footer;